import { render, staticRenderFns } from "./distributionPlan.vue?vue&type=template&id=2302d720&scoped=true"
import script from "./distributionPlan.vue?vue&type=script&lang=js"
export * from "./distributionPlan.vue?vue&type=script&lang=js"
import style0 from "./distributionPlan.vue?vue&type=style&index=0&id=2302d720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2302d720",
  null
  
)

export default component.exports